export const FaqsCategory = [
  {
    category_id: 1,
    heading: 'General FAQs',
    faqs: [
      {
        id: 1,
        question: 'What is Devsnest Tech School?',
        answer: `Devsnest is a tech educational institute that has a proven record of creating top-notch developers fulfilling the gap between college education and required tech skills for over 8000 students.
Devsnest Tech School is an online school that provides a 3-year Computer Science Under Graduate Program.`
      },
      {
        id: 2,
        question: 'How Devsnest is Different from other programs?',
        answer:
          'Devsnest Tech School curriculum is curated and will be taught by Tech Industry leaders, Unicorn startup CXOs, and FAANG-level Engineers. It’s a work-integrated program so students have 12+ months of industry experience as a full-time paid internship.'
      },
      {
        id: 3,
        question: 'Is Devsnest an online or on-campus program?',
        answer:
          'No, Devsnest is an Online Program. You don’t have to go on-campus for study but you can learn from anywhere.'
      }
    ]
  },
  {
    category_id: 2,
    heading: 'Application Process FAQs',
    faqs: [
      {
        id: 1,
        question: 'What are the steps to submit my application?',
        answer:
          'First, you have to verify your phone number. The second step is to fill in your personal and academic details. Take the scholarship test, passing which, you will receive an interview invitation. Based on your performance in an interview you will asked to pay the fees for reserving your seat.'
      },
      {
        id: 2,
        question:
          'Do I need to pay any application Fees to submit my application?',
        answer:
          'Yes, there is a 300 rupees application fee to give the mandatory scholarship test.'
      },
      {
        id: 3,
        question: 'What kind of information/documents do I need to submit?',
        answer:
          'Your personal details such as Name, DOB, email, phone no, and academic details such as 10th School, Board (CBSE/ICSE/ State board), Marks, 12th/Diploma details.'
      },
      {
        id: 4,
        question: 'What is the deadline for the application?',
        answer: 'Application closed'
        // 'Application deadline for Batch2 is 10th August, 2023. After that if seats remain we will notify on the website.'
      }
    ]
  },
  {
    category_id: 3,
    heading: 'Eligibility FAQs',
    faqs: [
      {
        id: 1,
        question: 'How can I check eligibility for this program?',
        answer:
          'If you are Class 12th pass out from the year of 2020-2023 or a diploma holder from 2021, 2022 or 2023.'
      },
      {
        id: 2,
        question: 'Do we need to have any other academic requirements?',
        answer: 'You should have cleared 10th, 12th/Diploma.'
      },
      {
        id: 3,
        question: 'I am 18 years old, can I apply for this program?',
        answer: 'Yes, students above 16 years can apply for this program.'
      }
    ]
  },
  {
    category_id: 4,
    heading: 'Test and Interview FAQs',
    faqs: [
      {
        id: 1,
        question: 'Is there any entrance exam that we are supposed to clear?',
        answer:
          'Yes, you have to clear Scholarship Test and the interview to get admission to the program.'
      },
      {
        id: 2,
        question: 'How we can prepare for the test?',
        answer:
          'We will check the general parameters which are required to enter into computer science such as English & Comprehension, Basic Mathematics, and Logical Reasoning.'
      },
      {
        id: 3,
        question: 'Will I be called for an Interview?',
        answer:
          'Based on your performance in the scholarship test you will either receive a rejection mail or an interview call from us.'
      },
      {
        id: 4,
        question: 'When we can get the results of the test?',
        answer:
          'After the interview process, we will mail you the results You can either be selected, waitlisted, or rejected.'
      }
    ]
  }
]
